<template>
  <div>
    <!-- banner -->
    <div style="width: 100%">
      <img
        style="width: 100%; height: 100%"
        src="@/images/common/banner.png"
        alt=""
      />
    </div>
    <!-- 专业物流服务 -->
    <div style="width: 100%; margin-bottom: 80px">
      <h3
        style="
          text-align: center;
          line-height: 80px;
          font-size: 36px;
          color: #333333;
        "
      >
        专业物流服务
      </h3>
      <div class="container">
        <div class="nav">
          <div class="box" v-for="item in list" :key="item.id">
            <div class="ft-service-innerbox-3">
              <img :src="item.image" alt="" srcset="" />
            </div>
            <div class="ft-service-text-icon position-relative">
              <div class="ft-service-icon">
                <img
                  style="widht: 100%; height: 100%"
                  :src="item.icon" 
                  alt=""
                  srcset=""
                />
              </div>
              <div class="ft-service-text">
                <div
                  style="
                    display: flex;
                    align-items: center;
                    padding-bottom: 15px;
                  "
                >
                  <img
                    style="
                      width: 32px;
                      height: 32px;
                      font-size: 0;
                      margin-right: 12px;
                    "
                    src="@/images/icon/KJY_yuan1.png" 
                    alt=""
                  />
                  <h3>{{ item.title }}</h3>
                </div>
                <p>
                  {{ item.text }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 广告banner -->
    <div class="rows">
      <span>我们的服务不止于此。了解我们如何为您和您的企业提供帮助。</span>
      <a href="javascript:;" class="btn">联系我们</a>
    </div>

    <!-- 专业的运输服务 -->
    <div class="main">
      <div class="box" v-for="item in lists" :key="item.id">
        <div class="bg" :style="{ backgroundImage: 'url(' + item.url + ')' }">
          <div class="abs">
            <span class="serial-no">{{ item.id }}</span>
            <h3>{{ item.text }}</h3>
            <p>{{ item.rask }}</p>
          </div>
          <a
            class="more-btn d-flex align-items-center justify-content-center"
            href="https://www.kingbogroup.com"
            target="_blank"
            ><i class="el-icon-right"></i
          ></a>
        </div>
      </div>
    </div>
    <!-- 我们共同应对您的物流挑战。 -->
    <div class="Gbanner4">
      <div class="images">
        <img src="@/images/common/map1.png" alt="" srcset="" />
      </div>
      <p>我们共同应对您的物流挑战。</p>
      <div class="box1">
        <div class="list">
          <div v-for="item in info" :key="item.id">
            <img :src="item.url | handlerImg" alt="" srcset="" />
            <h2>{{ item.num }}</h2>
            <span>{{ item.title }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 新闻资讯 -->
    <div class="newInfo">
      <div class="warper">
        <h3
          style="
            text-align: center;
            font-weight: 500;
            color: #333333;
            font-size: 36px;
            line-height: 160px;
          "
        >
          新闻资讯
        </h3>
        <div class="navlist">
          <div
            class="navbox"
            data-wow-duration="1500ms"
            data-wow-delay="300ms"
            v-for="item in newInfo"
            :key="item.id"
          >
            <div class="date">
              <span class="pl-30 pr-30">{{ item.time }}</span>
            </div>
            <div class="navbox-img">
              <img :src="item.url | handlerImg" alt="" />
            </div>
            <div class="navbox-text">
              <span>
                {{ item.text }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import KJY_nav1 from '@/images/icon/KJY_nav1.png';
import KJY_icon1 from '@/images/icon/KJY_icon1.png';
import KT_huochuan from '@/images/icon/KJY_nav2.png';
import KT_ser6 from '@/images/icon/KJY_icon2.png';
import KT_huoche from '@/images/icon/KJY_nav3.png';
import KT_ser8 from '@/images/icon/KJY_icon3.png';


export default {
  data () {
    return {
      list: [
        {
          id: 1,
          icon: 'https://minio.cargoee.com/cargoee/KT_feiji.png',
          image: 'https://minio.cargoee.com/cargoee/KT_ser4.jpeg',
          title: "空运服务",
          text: "一旦您的企业正确完成最后一英里交付，它就会成为您服务的标志，从而创造一个重要的商机。",
        },
        {
          id: 2,
          icon: "https://minio.cargoee.com/cargoee/KT_huochuan.png",
          image: "https://minio.cargoee.com/cargoee/KT_ser6.jpeg",
          title: "海运服务",
          text: "一旦您的企业正确完成最后一英里交付，它就会成为您服务的标志，从而创造一个重要的商机。",
        },
        {
          id: 3,
          icon: "https://minio.cargoee.com/cargoee/KT_huoche.png",
          image: "https://minio.cargoee.com/cargoee/KT_ser8.jpeg",
          title: "铁路运输",
          text: "一旦您的企业正确完成最后一英里交付，它就会成为您服务的标志，从而创造一个重要的商机。",
        },
      ],
      lists: [],
      info: [
        {
          id: 1,
          url: "https://minio.cargoee.com/cargoee/KT_kehu.png",
          num: "2200+",
          title: "满意的客户",
        },
        {
          id: 2,
          url: "https://minio.cargoee.com/cargoee/KT_tuan.png",
          num: "155+",
          title: "团队成员",
        },
        {
          id: 3,
          url: "https://minio.cargoee.com/cargoee/KT_jiang.png",
          num: "33",
          title: "获奖",
        },
        {
          id: 4,
          url: "https://minio.cargoee.com/cargoee/KT_dingdan.png",
          num: "12.8亿",
          title: "完成支付",
        },
      ],
      newInfo: [
        {
          id: 1,
          url: "https://minio.cargoee.com/cargoee/KT_news-1.png",
          time: "2021 年11月12日",
          text: "中国（宁波）跨境电子商务综合试验区领导小组办公室印发《宁波市支持跨境电子商务高质量发展的若干政策意见》，支持我国跨境电子商务高质量发展。从多个方面深入积极培育对外贸易竞争新优势，推动跨境电子商务按下发展快捷键。",
        },
        {
          id: 2,
          url: "https://minio.cargoee.com/cargoee/KT_news-2.png",
          time: "2021 年10月12日",
          text: "近日，随处可见的“限电令”成了热门话题，其实每年秋冬季开始，为了节能减排，都会限制用电。而今年，限电限产措施在多个省份密集推出，“双高”企业接连接到限产通知等情况轮流吸引着人们的眼球，堪称史上最严限电令。",
        },
        {
          id: 3,
          url: "https://minio.cargoee.com/cargoee/KT_news-3.png",
          time: "2021 年9月28日",
          text: "2021第十六届中国（深圳）国际物流与供应链博览会在深圳会展中心已经于9月23日拉开序幕，为期三天，国内首个以供应链为主题的博览会，鲸宝泊舱与你共同赴会，准备好了吗！物博会介绍：......",
        },
      ],
    }
  },
  mounted () {
    let lst = [
      {
        id: "01",
        text: "传统海运",
        rask: "传统式美国国际海运就是指商家把货运运输到选中的货代公司库房，后由货代公司将货运运输到特定的海港，必须目地国的顾客自取。就客户来讲，通常传统式国际海运的范畴相对性范围广。",
        url: "https://minio.cargoee.com/cargoee/KT_cs1.jpeg",
      },
      {
        id: "02",
        text: "拼箱",
        rask: "货主托运零散或小数量的货物由承运人负责装箱的一种方式。承运人接到这种货物后，按性质和目的地进行分类，把同一目的地、性质相同的货物拼装进同一个集装箱进行运输。",
        url: "https://minio.cargoee.com/cargoee/KT_cs2.jpeg",
      },
      {
        id: "03",
        text: "FBA头程",
        rask: "FBA头程为中国到亚马逊仓库服务的代名词。为FBA卖家提供多样化、个性化的头程服务。可以直接使用快递、空运服务，直接发货到亚马逊仓库;也可以先通过海运,将货物发往不同的亚马逊仓库。",
        url: "https://minio.cargoee.com/cargoee/KT_cs3.jpeg",
      },
      {
        id: "04",
        text: "海外仓",
        rask: "海外仓是指企业建立在海外的仓储设施。在跨境贸易和跨境电商销售中，海外仓的作用是国内企业将商品通过国际运输的方式运往目标市场国家，并在当地通过租赁或者自建形式建立仓库。",
        url: "https://minio.cargoee.com/cargoee/KT_cs4.jpeg",
      },
    ]
    lst.forEach((item, index) => {
      item.url = this.filtimg(item.url)
    })
    this.lists = lst
    // console.log(this.lists);
  },
  methods: {
    filtimg (e) {
      if (!/https?:/.test(e)) {
        return (
          "http://api.iyoucang.com" +
          (/\/admin/.test(e) ? e : "/admin/sys-file/cargoee/" + e)
        )
      } else {
        return e || ""
      }
    },
  },
};
</script>
<style scoped>
.warper {
  width: 12rem;
  margin: 0 auto;
}
/* 专业物流服务 */
.container {
  width: 12rem;
  margin: 0 auto;
}
.nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.box {
  position: relative !important;
}

.ft-service-innerbox-3 {
  position: relative !important;
  /* width: 380px;
  height: 304px; */
  overflow: hidden;
}
.ft-service-innerbox-3::before {
  left: -15px;
  width: 110%;
  content: "";
  height: 100px;
  bottom: -57px;
  position: absolute;
  background-color: #f2f3f5;
  transform: rotate(-13deg);
}
.ft-service-innerbox-3 img {
  max-width: 100%;
  height: auto;
}
.ft-service-text-icon {
  padding: 59px 30px 75px;
  top: -70px;
  max-width: 90%;
  margin: 0 auto;
  margin-bottom: -70px;
  -webkit-transition: 500ms all ease;
  transition: 500ms all ease;
  background-color: white;
  -webkit-box-shadow: 0px 0px 29px 0px rgb(12 12 12 / 7%);
  box-shadow: 0px 0px 29px 0px rgb(12 12 12 / 7%);
  box-sizing: border-box;
  width: 340px;
  height: 260px;
  position: relative;
}
.ft-service-icon {
  right: 30px;
  top: -50px;
  position: absolute;
  z-index: 1;
  width: 95px;
  height: 95px;
  border-radius: 100%;
  background-color: #fff;
  border: 10px solid #008cfb;
  transition: 500ms all ease;
}

.ft-service-text h3 {
  color: #121213;
  font-size: 22px;
  font-weight: 700;
  -webkit-transition: 500ms all ease;
  transition: 500ms all ease;
}
.ft-service-text p {
  color: #121213;
  -webkit-transition: 500ms all ease;
  transition: 500ms all ease;
}
.box:hover .ft-service-text-icon {
  background: #01011c;
}
.box:hover .ft-service-icon {
  border: 10px solid #fa4317;
}
.box:hover .ft-service-text p,
.box:hover .ft-service-text h3 {
  color: #fff;
}
/* 专业物流服务end */
/* 广告banner */
.rows {
  text-align: center;
  /* padding-top: 66px; */
}
.rows span {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #021a35;
}
.btn {
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  margin-left: 20px;
  padding: 10px 30px;
  background-color: #3b6aff;
}
/* 广告banner end */
/* 专业的运输服务 */
.main {
  margin-top: 50px;
  width: 100%;
  height: 525px;
  display: flex;
  align-items: center;
}
.main .box {
  width: 25%;
  height: 100%;
}
.main .bg {
  width: 100%;
  height: 100%;
  border-right: 1px solid #8a8a8a;

  background-size: 100%;
  background-repeat: no-repeat;
  position: relative;
}
.main .bg::before {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  content: "";
  position: absolute;
  -webkit-transition: 500ms all ease;
  transition: 500ms all ease;
  background-color: rgba(0, 0, 0, 0.65);
}

.abs {
  position: absolute;
  left: 60px;
  bottom: -25px;
  max-width: 335px;
  transition: 500ms all ease;
}
.box:hover .bg::before {
  background-color: rgba(0, 67, 135, 0.85);
}
.box:hover p {
  opacity: 1;
}
.box:hover .abs {
  bottom: 90px;
}

.serial-no {
  color: #fa4318;
  font-size: 20px;
  font-weight: 500;
}
.abs h3 {
  color: #fff;
  font-size: 28px;
  font-weight: 700;
  padding: 25px 0px 25px;
}
.more-btn {
  left: 60px;
  color: #fff;
  width: 45px;
  height: 45px;
  bottom: 40px;
  position: absolute;
  text-align: center;
  border: 2px solid rgba(255, 255, 255, 0.6);
}
.el-icon-right {
  font-size: 20px;
  line-height: 45px;
}
.abs p {
  opacity: 0;
  color: #fff;
  line-height: 1.688;
  padding-bottom: 35px;
  -webkit-transition: 500ms all ease;
  transition: 500ms all ease;
}
/* 专业的运输服务 end */
/* 我们共同应对您的物流挑战。 */
.Gbanner4 {
  width: 100%;
  height: 800px;
  background-image: url("../../images/common/shape-bg.png");
  background-size: 100%;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.Gbanner4 .box1 {
  width: 720px;
  height: 200px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}
.Gbanner4 .list {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.Gbanner4 .list div {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.Gbanner4 .list img {
  margin-bottom: 24px;
}
.Gbanner4 .list h2 {
  font-size: 40px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #e9730b;
  margin-bottom: 15px;
}
.Gbanner4 .list span {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #494e53;
}
.Gbanner4 p {
  position: absolute;
  left: 0;
  top: 106px;
  right: 0;
  font-size: 48px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #021a35;
  text-align: center;
}
/* 我们共同应对您的物流挑战。 end */
/* 新闻资讯 */
.newInfo {
  width: 100%;
  background: #f6f7f9;
  padding-bottom: 100px;
  box-sizing: border-box;
}
.navlist {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.navbox {
  width: 380px;
  position: relative;
}
.navbox .date {
  position: absolute;
  left: 50%;
  top: 222px;
  transform: translateX(-50%);
  box-shadow: 0px 10px 30px 0px rgb(0 0 0 / 5%);
  background: #fff;
  display: inline-block;
  padding: 0 38px;
  z-index: 9;
}
.navbox .date span {
  line-height: 40px;
  white-space: nowrap;
  font-size: 12px;
  text-transform: uppercase;
  color: #7e8591;
  letter-spacing: 1px;
}
.navbox-img {
  width: 100%;
  height: 244px;
  overflow: hidden;
  font-size: 0;
}
.navbox-img img {
  width: 100%;
  height: 100%;
  -webkit-transition: all 0.3s ease-out 0s;
  -moz-transition: all 0.3s ease-out 0s;
  -ms-transition: all 0.3s ease-out 0s;
  -o-transition: all 0.3s ease-out 0s;
  transition: all 0.3s ease-out 0s;
}
.navbox-text {
  padding: 24px 30px;
  box-sizing: border-box;
  background: #ffffff;
  height: 170px;
  box-shadow: 0px 2px 20px 0px rgba(15, 17, 32, 0.05);
}
.navbox-text span {
  font-size: 14px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #727375;
  line-height: 24px;
}
.kjy-label {
  width: 142px;
  height: 34px;
  position: absolute;
  right: 0;
  top: -15px;
  font-size: 0;
  z-index: 9;
}
.kjy-label img {
  width: 100%;
  height: 100%;
}
.kyj-time {
  position: absolute;
  width: 142px;
  height: 34px;
  top: -15px;
  right: 0;
  text-align: center;
  z-index: 9;
}
.kyj-time span {
  font-size: 16px;
  font-weight: 400;
  color: #ffffff;
  line-height: 34px;
}
.navbox:hover .navbox-img img {
  transform: scale(1.1);
}
/* 新闻资讯 end*/
</style>



// WEBPACK FOOTER //
// src/components/indexMain/index.vue